import { Component, OnInit } from '@angular/core';
import { startOfMonth, startOfDay, startOfISOWeek } from 'date-fns';
import { Utils } from 'app/common/util';
import { GameConfig } from 'app/common/gameConfig';
import { ApiService } from 'app/providers/api/api.service';
import { NzModalService, NzMessageService } from 'ng-zorro-antd';

@Component({
  selector: 'app-personal-bet-record',
  templateUrl: './personal-bet-record.component.html',
  styleUrls: ['./personal-bet-record.component.css']
})
export class PersonalBetRecordComponent implements OnInit {

  // token
  public token: string;
  // 时间范围
  public time_range: any = { '今日': [startOfDay(new Date()), new Date()], '本周': [startOfISOWeek(new Date()), new Date()], '本月': [startOfMonth(new Date()), new Date()] };
  public date_range: any = [startOfDay(new Date()), new Date()];
  // 编号类型
  public code_type: string = 'bet';
  public bet_code: string;
  public issue_code: string;
  // 用户名
  public user_name: string;
  // 游戏名称
  public game_name_data: Array<any> = [];
  public cur_game_name_val: string = 'all';
  // 玩法类型
  public play_type_array: Array<any> = [];
  public play_type_data: Array<any> = [];
  public cur_play_type_val: string = 'all';
  // 玩法名称
  public play_name_data: Array<any> = [];
  public cur_play_name_val: string = 'all';

  // 数据源
  public data_source_total: Array<any> = [];
  public data_source_detail: Array<any> = [];
  public is_loading: boolean = false;
  // 数据数量
  public total_num: number;
  // 单页容量
  public page_size: number = 10;
  // 当前页码
  public curr_page: number = 1;
  // 是否显示分页
  public is_show: boolean = false;
  // 注单详情
  public bet_details: any;

  // ******************************************************************
  public detail_visible: boolean = false;

  constructor(
    private api: ApiService,
    private modalService: NzModalService,
    private msgService: NzMessageService

  ) {
    if (localStorage.getItem('token')) {
      this.token = localStorage.getItem('token');

      this.search_handler();
    }
  }

  ngOnInit() {
    this.api.get_request_game_list_info().subscribe(data => {
      if (data) {
        Utils.game_list = data['game_list'];
        Utils.game_type_array = data['game_type'];
        // 初始化游戏名称
        this.init_game_name_data_handler();
      }
    });

    this.api.get_request_ssc_game_config().subscribe(data => {
      if (data) {
        GameConfig.ssc_game_config = data['ssc_game_config'];
        GameConfig.tx_game_config = data['tx_game_config'];
      }
    });

    this.api.get_request_11x5_game_config().subscribe(data => {
      if (data) {
        GameConfig.x115_game_config = data['x115_game_config'];
      }
    });

    this.api.get_request_k3_game_config().subscribe(data => {
      if (data) {
        GameConfig.k3_game_config = data['k3_game_config'];
      }
    });

    this.api.get_request_pk10_game_config().subscribe(data => {
      if (data) {
        GameConfig.pk10_game_config = data['pk10_game_config'];
      }
    });

    this.api.get_request_f3d_game_config().subscribe(data => {
      if (data) {
        GameConfig.dipin_game_config = data['f3d_game_config'];
      }
    });

    this.api.get_request_plw_game_config().subscribe(data => {
      if (data) {
        GameConfig.plw_game_config = data['plw_game_config'];
      }
    });

    this.api.get_request_lhc_game_config().subscribe(data => {
      if (data) {
        GameConfig.lhc_game_config = data['lhc_game_config'];
      }
    });
  }

  /**
   * 初始化游戏名称
   *
   * @memberof PersonalBetRecordComponent
   */
  public init_game_name_data_handler() {
    Utils.game_list.forEach((item, index) => {
      let obj = {};
      switch (index) {
        case 0:
          obj['label'] = '时时彩';
          break;
        case 1:
          obj['label'] = '11选5';
          break;
        case 2:
          obj['label'] = '快3';
          break;
        case 3:
          obj['label'] = 'PK10';
          break;
        case 4:
          obj['label'] = '低频';
          break;
        case 5:
          obj['label'] = '六合彩';
          break;
        case 6:
          obj['label'] = 'PC蛋蛋';
          break;
        default: break;
      }
      obj['children'] = [];
      item.forEach(element => {
        let g = {};
        g['value'] = element['id'].toString();
        g['label'] = element['name'];
        obj['children'].push(g);
      });
      this.game_name_data.push(obj);
    });
  }

  /**
   * 切换游戏名称
   *
   * @param {*} e
   * @memberof PersonalBetRecordComponent
   */
  public change_game_name_handler(e: any) {
    this.cur_play_type_val = 'all';
    this.play_type_data = [];
    this.cur_play_name_val = 'all';
    this.play_name_data = [];
    let type;

    for (let i = 0; i < Utils.game_type_array.length; i++) {
      let id = Number(e);
      let index = Utils.game_type_array[i].indexOf(id);
      if (index !== -1) {
        type = i;
        this.update_play_type_data_handler(id, type);
        break;
      }
    }
  }

  /**
   * 更新玩法类型数据
   *
   * @param {number} type
   * @memberof PersonalBetRecordComponent
   */
  public update_play_type_data_handler(id: number, type: number) {
    this.play_type_array = [];
    this.play_type_data = [];

    let arry;
    switch (type) {
      case 0:
        if (id === 64 || id === 100 || id === 101) {
          arry = GameConfig.tx_game_config;
        } else {
          arry = GameConfig.ssc_game_config;
        }
        break;
      case 1: arry = GameConfig.x115_game_config; break;
      case 2: arry = GameConfig.k3_game_config; break;
      case 3: arry = GameConfig.pk10_game_config; break;
      case 4:
        if (id !== 14) {
          arry = GameConfig.dipin_game_config;
        } else {
          arry = GameConfig.plw_game_config;
        }
        break;
      case 5: arry = GameConfig.lhc_game_config; break;
      case 6: arry = GameConfig.pcdd_game_config; break;
      default: arry = []; break;
    }

    arry.forEach(item => {
      this.play_type_array.push(item);

      let obj = {};
      obj['value'] = item['id'];
      obj['label'] = item['name_cn'];
      this.play_type_data.push(obj);
    });
  }

  /**
   * 切换玩法类型
   *
   * @memberof PersonalBetRecordComponent
   */
  public change_play_type_handler(e: any) {
    this.cur_play_name_val = 'all';
    this.play_name_data = [];

    this.play_type_array.forEach(item => {
      let id = Number(e);
      if (item['id'] === id) {
        item['children'].forEach(element => {
          element['children'].forEach(play => {
            let p = {};
            p['value'] = play['id'].toString();
            p['label'] = play['name_cn'];
            this.play_name_data.push(p);
          });
        });
      }
    });
  }

  /**
   * 搜索操作
   *
   * @memberof PersonalBetRecordComponent
   */
  public search_handler() {
    this.is_loading = true;
    let start_time = Utils.formate_time(new Date(this.date_range[0]), 'yyyy-MM-dd hh:mm:ss');
    let end_time = Utils.formate_time(new Date(this.date_range[1]), 'yyyy-MM-dd hh:mm:ss');

    if (this.code_type === 'bet') {
      this.issue_code = '';
    } else {
      this.bet_code = '';
    }

    this.api.get_bet_history_recode_info(
      this.curr_page,
      this.token,
      start_time,
      end_time,
      this.user_name,
      this.cur_game_name_val === 'all' ? '0' : this.cur_game_name_val,
      this.cur_play_name_val === 'all' ? '0' : this.cur_play_name_val,
      this.bet_code,
      this.issue_code
    ).subscribe(data => {
      this.is_loading = false;

      if (data && data['isSuccess']) {

        this.total_num = data['data']['bet_record']['total'];
        this.curr_page = data['data']['bet_record']['current_page'];

        // 总计记录
        this.data_source_total = [];
        let total_record = new TotalRecord();
        total_record.user_name = data['data']['total_record']['user_name'];
        total_record.bet_total_val = Number(data['data']['total_record']['total_bet_value']);
        total_record.prize_total_val = Number(data['data']['total_record']['total_prize_value']);
        total_record.bet_reward_val = Number(data['data']['total_record']['total_commission_value']);
        total_record.game_profit = Number(data['data']['total_record']['total_prifit_value']);

        this.data_source_total.push(total_record);

        // 详情记录
        this.data_source_detail = [];
        data['data']['bet_record']['data'].forEach(item => {
          let detail_record = new DetailRecord();
          detail_record.id = item['bet_id'];
          // detail_record.user_name = item['user_name'];
          detail_record.game_name = item['lottery_id'];
          detail_record.bet_code = item['bet_code'];
          detail_record.issue = item['issue'];
          detail_record.play_id = Number(item['play']);
          detail_record.bet_content = item['bet_content'];
          detail_record.bet_val = Number(item['bet_value']);
          detail_record.prize_val = Number(item['prize_value']);
          // detail_record.prize_group = Number(item['prize_group']);
          detail_record.bet_status = Number(item['bet_status']);
          this.data_source_detail.push(detail_record);
        });
        if (this.data_source_detail.length > 0) {
          this.is_show = true;
        }
      } else {
        // 错误提示
        let error = data['data']['error'];
        this.modalService.error({
          nzTitle: '温馨提示',
          nzContent: error,
          nzCancelText: null,
        });
      }
    });
  }

  /**
   * 根据页面获取信息
   *
   * @param {*} e
   * @memberof PersonalBetRecordComponent
   */
  public get_info_by_page(e: any) {
    this.curr_page = Number(e);
    this.search_handler();
  }

  /**
   * 显示注单详细信息
   *
   * @param {number} id
   * @memberof PersonalBetRecordComponent
   */
  public get_bet_detail_info(id: any) {
    this.api.get_bet_detail_info_by_id(id, this.token).subscribe((data) => {
      if (data && data['isSuccess']) {
        let info = data['data'];

        let bd = new BetDetail();
        bd.id = Number(info['bet_id']);
        bd.lottery = info['lottery'];
        bd.game_name = info['game_name'];
        bd.bet_code = info['bet_code'];
        bd.time = info['time'];
        bd.play = info['play'];
        bd.issue = info['issue'];
        bd.game_mode = Number(info['game_mode']);
        bd.multiple = Number(info['multiple']);
        bd.bet_value = Number(info['bet_value']);
        bd.bet_status = info['bet_status'];
        bd.prize_value = Number(info['prize_value']);
        bd.bet_content = info['bet_content'];
        bd.is_cancel = info['is_cancel'];

        let p_arr = [];
        info['position'].split('').forEach((e, n) => {
          let p: string;
          switch (Number(e)) {
            case 0: p = '万'; break;
            case 1: p = '千'; break;
            case 2: p = '百'; break;
            case 3: p = '十'; break;
            case 4: p = '个'; break;
            default: break;
          }
          p_arr[n] = p;
        });
        bd.position = p_arr.join(',');

        this.bet_details = bd;
        this.detail_visible = true;
      } else {
        // 错误提示
        let error = data['data']['error'];
        this.modalService.error({
          nzTitle: '温馨提示',
          nzContent: error,
          nzCancelText: null,
        });
      }

    });

  }

  /**
   * 关闭详细信息窗口
   *
   * @memberof PersonalBetRecordComponent
   */
  public close_detail_canvas_handler() {
    this.detail_visible = false;
  }

  /**
   * 点击撤单
   *
   * @memberof PersonalBetRecordComponent
   */
  public confirm_cancel_handler() {
    this.modalService.warning({
      nzTitle: '温馨提示',
      nzContent: '您确定撤单吗？',
      nzOnOk: () => {
        this.drop_bet_handler();
      }
    });
  }

  /**
   * 撤单操作
   *
   * @memberof PersonalBetRecordComponent
   */
  public drop_bet_handler() {
    this.api.drop_bet_info_by_id(this.bet_details.id, this.token).subscribe(data => {
      if (data && data['isSuccess']) {
        this.bet_details.bet_status = 1;
        this.bet_details.is_cancel = 0;

        let rd = this.data_source_detail.filter(record => record.id === this.bet_details.id)[0];
        rd.bet_status = 1;

        this.msgService.success(data['data']['msg']);
      } else {
        // 错误提示
        let error = data['data']['error'];
        this.modalService.error({
          nzTitle: '温馨提示',
          nzContent: error,
          nzCancelText: null,
        });
      }
    });
  }
}

class TotalRecord {
  // 用户名称
  public user_name: string;
  // 投注总额
  public bet_total_val: number;
  // 派奖总额
  public prize_total_val: number;
  // 投注返点
  public bet_reward_val: number;
  // 游戏盈亏
  public game_profit: number;

  constructor() { }
}

class DetailRecord {
  // ID
  public id: number;
  // 用户名称
  public user_name: string;
  // 游戏名称
  public game_name: string;
  // 注单编号
  public bet_code: string;
  // 奖旗编号
  public issue: string;
  // 玩法名称
  public play_id: number;
  // 投注内容
  public bet_content: string;
  // 投注金额
  public bet_val: number;
  // 奖金金额
  public prize_val: number;
  // 奖金组	
  public prize_group: number;
  // 注单状态
  public bet_status: number;

  constructor() { }
}

class BetDetail {
  // ID
  public id: number;
  // 开奖号码
  public lottery: any;
  // 游戏名称
  public game_name: any;
  // 注单编号
  public bet_code: string;
  // 投注时间
  public time: string;
  // 玩法名称
  public play: any;
  // 游戏奖期
  public issue: string;
  // 游戏模式
  public game_mode: any;
  // 投注倍数
  public multiple: number;
  // 投注金额
  public bet_value: number;
  // 注单状态
  public bet_status: any;
  // 奖金金额
  public prize_value: number;
  // 投注内容
  public bet_content: string;
  // 是否可以撤单
  public is_cancel: any;
  // 位置
  public position: string;

  constructor() { }
}
